import styles from "./styles.module.scss";

export default function CoachBanner() {
  return (
    <section className={styles.container}>
      <div className="container" data-aos="fade-right">
        <h2 className={styles.title}>Programa de aluno monitor</h2>
        <p>
          Alguns alunos de turmas mais avançadas são selecionados pelo bom
          desempenho para serem alunos monitores.
        </p>
        <p>
          O papel do aluno monitor é também dar apoio, ajudando os alunos a
          explorar pontos-chave como organização, comunicação e resolução de
          desafios.
        </p>

        <div className={styles.listWrapper}>
          <h3 className={styles.subtitle}>
            Sendo aluno monitor na Kenzie você:
          </h3>
          <ul>
            <li>
              Aprende muito mais! Nosso cérebro aprende 94% mais ensinando;
            </li>
            <li>Compartilha conhecimentos práticos e teóricos;</li>
            <li>
              Desenvolve na prática soft skills como gestão do tempo e
              autonomia;
            </li>
            <li>Ganha autoconfiança guiando outros alunos em projetos;</li>
            <li>E, claro, recebe remuneração pelo seu trabalho :)</li>
          </ul>
        </div>
      </div>
    </section>
  );
}
